import { styled } from '@mui/material/styles';
import { Box, Card, CardContent, Grid, Typography } from '@mui/material';

export const StyledCard = styled(Card)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

export const StyledCardContent = styled(CardContent)(({ theme }) => ({
  // Padding ya viene por defecto de CardContent
}));

export const CardTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1.5),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  fontWeight: 600,
}));

export const StyledGrid = styled(Grid)(({ theme }) => ({
  // Grid ya tiene su propio spacing
}));

export const InfoBox = styled(Box)({
  marginBottom: 0,
});

export const InfoLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(0.25),
}));

export const InfoValue = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
}));
